import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;

  > div {
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #C4C4C4;
    cursor: pointer;
    transition: all 0.2s linear;

    &:hover {
      transform: scale(1.03);
    }
  }
`

export const ViewSmallBox = styled.div`
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  background-color: #222430;
  opacity: 0.7;
  svg {
    path {
      fill: white;
    }
  }
  ${({ active }) => active && css`
    background-color: #434656 !important;
    box-shadow: rgb(4 17 29 / 25%) 0px 0px 8px 0px;
    opacity: 1;
    svg {
      path {
        fill: #AAFF26;
      }
    }
  `}
`

export const ViewLargeBox = styled.div`
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  background-color: #222430;
  opacity: 0.7;
  svg {
    path {
      fill: white;
    }
  }
  ${({ active }) => active && css`
    box-shadow: rgb(4 17 29 / 25%) 0px 0px 8px 0px;
    background: #434656;
    opacity: 1;
    svg {
      path {
        fill: #AAFF26;
      }
    }
  `}
`
